module.exports = __webpack_public_path__ + "img/q_img09.37570187.jpg";